
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/overseas-education-fair/[slug]",
      function () {
        return require("private-next-pages/overseas-education-fair/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/overseas-education-fair/[slug]"])
      });
    }
  